<mmx-history-dialog
  [title]="'balance.history.title' | translate"
  [history$]="history$"
  [loading$]="loading$"
  [emptyText]="(error$ | async) ? ('balance.history.error' | translate) : ('balance.history.empty' | translate)"
  [tz]="tz"
>
  <ng-template let-log>
    {{ describe(log) }}
  </ng-template>
</mmx-history-dialog>
